var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc24Dollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M7 8.5c0-2.204 1.738-3.999 4.005-4.41l-.004-.045L11 3a1 1 0 1 1 2 0v1l-.004.09C15.263 4.501 17 6.295 17 8.5a1 1 0 0 1-1.993.117L15 8.5C15 7.151 13.684 6 12 6S9 7.151 9 8.5c0 1.299 1.22 2.415 2.814 2.495L12 11c2.734 0 5 1.983 5 4.5 0 2.202-1.735 3.995-4 4.41V21a1 1 0 1 1-2 0v-1.09c-2.265-.414-4-2.207-4-4.41a1 1 0 1 1 2 0c0 1.349 1.316 2.5 3 2.5s3-1.151 3-2.5c0-1.299-1.22-2.415-2.814-2.495L12 13c-2.734 0-5-1.983-5-4.5Z",
  clipRule: "evenodd"
})));
export default SvgIc24Dollar;